import { render, staticRenderFns } from "./ActivityConfigFormModal.vue?vue&type=template&id=9c4b7cd0&scoped=true"
import script from "./ActivityConfigFormModal.vue?vue&type=script&lang=js"
export * from "./ActivityConfigFormModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigFormModal.vue?vue&type=style&index=0&id=9c4b7cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4b7cd0",
  null
  
)

export default component.exports